export default __webpack_public_path__ + "static/articulo4-31a09e3d0588999ce3f7559e1574cbe2.png";